<template>
  <div class="home-blockquote-item">
    <div
      class="home-blockquote-item__quote"
      v-if="fields && fields.quote"
      v-html="fields.quote.value"
    />

    <sc-text
      tag="div"
      class="home-blockquote-item__name"
      v-if="fields && fields.name"
      :field="fields.name"
    />

    <div>
      <sc-text
        class="home-blockquote-item__title"
        v-if="fields && fields.title"
        :field="fields.title"
      />
      <span v-if="fields && fields.title && fields.organization && fields.organization.value !== ''"
        >,
      </span>
      <sc-text
        class="home-blockquote-item__organization"
        v-if="fields && fields.organization"
        :field="fields.organization"
      />
    </div>
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-Blockquote-Item',
  components: {
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.home-blockquote {
  &-item {
    padding-bottom: 2rem;
    &__quote {
      font-size: 1.8rem;
      line-height: 2.4rem;
      font-style: italic;
      color: $dark-blue;
      margin-bottom: 2rem;
      font-weight: 400;

      @include tablet-up {
        font-size: 2.4rem;
        line-height: 3.5rem;
      }
    }

    &__name {
      font-size: 1.6rem;
      line-height: 2rem;
      font-weight: 700;
      color: $dark-blue;

      @include tablet-up {
        font-size: 2rem;
        line-height: 2.8rem;
      }
    }

    &__title,
    &__organization {
      font-size: 1.6rem;
      line-height: 2rem;
      font-weight: 400;
      color: $dark-blue;

      @include tablet-up {
        font-size: 2rem;
        line-height: 2.6rem;
      }
    }
  }
}
</style>
